/**
 * Ensures that the given value is an array.
 * @param value The value to check.
 */
export function castArray<T>(value: T | T[]) : T[] {
  return Array.isArray(value) ? value : [value];
}
